import { Component, OnInit, inject } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'

import { Enums, Profile } from '@cyborg-monorepo/hunter/common'
import { DialogRef, DIALOG_DATA } from '@hyperkit'

import { UserService } from '../../../../shared/services/user.service'

@Component({
  standalone: false,
  selector: 'edit-user-dialog',
  templateUrl: './edit-user-dialog.component.html',
  styleUrls: ['./edit-user-dialog.component.scss'],
})
export class EditUserDialogComponent implements OnInit {
  dialogRef = inject(DialogRef)
  private userService = inject(UserService)
  user = inject<Profile>(DIALOG_DATA, { optional: true })

  public formGroup: FormGroup
  public roles: Array<string> = []
  public error: string

  public ngOnInit(): void {
    this.formGroup = new FormGroup({
      firstName: new FormControl(this.user.firstName, [Validators.required]),
      lastName: new FormControl(this.user.lastName, [Validators.required]),
      email: new FormControl(this.user.email, [
        Validators.required,
        Validators.email,
      ]),
      role: new FormControl(this.user.role, [Validators.required]),
    })

    this.roles = Object.values(Enums.UserRoleEnum)
  }

  public onSubmit(): void {
    this.userService.updateUser(this.user.id, this.formGroup.value).subscribe(
      () => {
        this.dialogRef.close()
      },
      (error) => {
        this.error = error.message
      },
    )
  }

  public onClose(): void {
    this.dialogRef.close()
  }
}
